<template>
  <v-layout>
    <v-flex xs12>
    <v-card class="mt-2" width="100%">
      <v-card-title>
      <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">
        <v-btn color="primary" dark slot="activator" class="mb-2">New template</v-btn>
        <v-card>
          <v-toolbar dark color="primary">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{formTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click.native="save" :disabled="!newTemplateValid">Save</v-btn>
        </v-toolbar>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                <v-tabs icons-and-text centered color="grey lighten-4">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab href="#tab-1">
                  Options
                  <v-icon>settings_applications</v-icon>
                </v-tab>
                <v-tab href="#tab-2">
                  Items
                  <v-icon>assignment</v-icon>
                </v-tab>
                <v-tab href="#tab-3">
                  Extras
                  <v-icon>mdi-playlist-edit</v-icon>
                </v-tab>
                <v-tab-item value="tab-1" class="pa-2">
                  <v-form ref="newTemplate" v-model="newTemplateValid">
                  <v-text-field 
                    label="Template Name" 
                    v-model="editedItem.name"
                    :rules="[v => !!v || 'Name is required']" 
                    required>
                  </v-text-field>
                  <v-checkbox label="Optional" v-model="editedItem.optional"></v-checkbox>
                  <v-checkbox label="Default for new job" v-model="editedItem.required"></v-checkbox>
                  </v-form>
                </v-tab-item>
                <v-tab-item value="tab-2" class="pa-2">
                <v-card>
                  <v-card-title>
                    Add New Item
                  </v-card-title>
                  <v-card-text>
                  <v-text-field v-model="newTemplateItem.title"
                  label="Item Title">
                  </v-text-field>
                  <v-text-field v-model="newTemplateItem.text"
                  label="Item Text">
                  </v-text-field>
                  <v-checkbox label="Optional" v-model="newTemplateItem.optional"></v-checkbox>
                  <v-checkbox label="Web Service Test" v-model="newTemplateItem.test" @change="newTemplateItem.photo = false"></v-checkbox>
                  <v-checkbox :disabled="newTemplateItem.test" label="Image" v-model="newTemplateItem.photo"></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" @click="addNewTemplateItem()" v-if="editItemIndex === -1">Add</v-btn>
                      <v-btn color="primary" @click="addNewTemplateItem()" v-else>Edit</v-btn>
                      <v-btn @click="cancelItem()" v-if="editItemIndex !== -1">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-list three-line avatar>
                    <template v-for="(item, index) in editedItem.items">
                    <v-divider v-if="index > 0"></v-divider>
                    <v-subheader v-else>Template Items</v-subheader>
                    <v-list-tile :key="index">
                      <v-list-tile-action>
                        <v-btn v-if="index > 0" icon class="mx-0" @click.stop="moveTemplateItemUp(index)">
                          <v-icon color="primary">keyboard_arrow_up</v-icon>
                        </v-btn>
                        <v-spacer v-if="index < 1 || index >= editedItem.items.length -1"></v-spacer>
                        <v-btn v-if="index < editedItem.items.length -1" icon class="mx-0" @click.stop="moveTemplateItemDown(index)">
                          <v-icon color="primary">keyboard_arrow_down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-avatar>
                        <v-icon icon v-html="item.photo ? 'add_a_photo' : 'description'"></v-icon>
                        <v-icon icon v-html="item.optional ? '': 'visibility'"></v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.title}}</v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.text"></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="newTemplateItem = JSON.parse(JSON.stringify(editedItem.items[index])); editItemIndex = index">
                          <v-icon color="teal">edit</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="editedItem.items.splice(index, 1)">
                          <v-icon color="pink">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                    </template>
                  </v-list>
                  </v-tab-item>
                <v-tab-item value="tab-3" class="pa-2">
                <v-card>
                  <v-card-title>
                    Add New Extra
                  </v-card-title>
                  <v-card-text>
                  <v-combobox 
                    v-model="newTemplateExtra.name"
                    label="Item Title"
                    :items="extrasList"
                    :readonly="newTemplateExtra.type === 'sim'"
                  >
                  </v-combobox>
                  <v-text-field label="Default" v-model="newTemplateExtra.default"></v-text-field>
                  <v-select 
                    v-model="newTemplateExtra.type"
                    label="Item Type"
                    :items="['uid', 'sim', 'choice', 'text', 'number']"
                  >
                  </v-select>
                  <v-text-field v-if="newTemplateExtra.type == 'number'" label="Step" v-model="newTemplateExtra.step" type="number"></v-text-field>
                  <v-combobox
                    v-if="newTemplateExtra.type == 'choice'" 
                    v-model="newTemplateExtra.options"
                    label="Item Options"
                    multiple
                    chips
                    deletable-chips
                  >
                  </v-combobox>
                  </v-select>
                  <v-checkbox label="Required" :readonly="newTemplateExtra.type === 'uid'" v-model="newTemplateExtra.required"></v-checkbox>
                  <v-select 
                    v-model="newTemplateExtra.permissions.customer"
                    label="Customer Permissions"
                    :items="['none', 'read', 'write']"
                  >
                  </v-select>
                  <v-select 
                    v-model="newTemplateExtra.permissions.sales"
                    label="Sales Permissions"
                    :items="['none', 'read', 'write']"
                  >
                  </v-select>
                  <v-select 
                    v-model="newTemplateExtra.permissions.support"
                    label="Support Permissions"
                    :items="['none', 'read', 'write']"
                  >
                  </v-select>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" @click="addNewTemplateExtra()" v-if="editExtraIndex === -1">Add</v-btn>
                      <v-btn color="primary" @click="addNewTemplateExtra()" v-else>Edit</v-btn>
                      <v-btn @click="cancelExtra()" v-if="editExtraIndex !== -1">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-list three-line avatar>
                    <template v-for="(item, index) in editedItem.extras">
                    <v-divider v-if="index > 0"></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-btn v-if="index > 0" icon class="mx-0" @click.stop="moveExtraUp(index)">
                          <v-icon color="primary">keyboard_arrow_up</v-icon>
                        </v-btn>
                        <v-spacer v-if="index < 1 || index >= editedItem.extras.length -1"></v-spacer>
                        <v-btn v-if="index < editedItem.extras.length -1" icon class="mx-0" @click.stop="moveExtraDown(index)">
                          <v-icon color="primary">keyboard_arrow_down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.name}}</v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.type"></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="newTemplateExtra = JSON.parse(JSON.stringify(editedItem.extras[index])); editExtraIndex = index">
                          <v-icon color="teal">edit</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="editedItem.extras.splice(index, 1)">
                          <v-icon color="pink">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                    </template>
                  </v-list>
                  </v-tab-item>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
        </v-card>
      </v-dialog>
        <v-spacer></v-spacer>
      </v-card-title>
        <v-list>
          <template v-for="(item, i) in templates">
          <v-list-tile avatar :key="i">
            <v-list-tile-action>
              <v-btn v-if="i > 0" icon class="mx-0" @click.stop="moveItemUp(item)">
                <v-icon color="primary">keyboard_arrow_up</v-icon>
              </v-btn>
              <v-spacer v-if="i < 1 || i >= templates.length -1"></v-spacer>
              <v-btn v-if="i < templates.length -1" icon class="mx-0" @click.stop="moveItemDown(item)">
                <v-icon color="primary">keyboard_arrow_down</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.name"></v-list-tile-title>
            </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon class="mx-0" @click.stop="editItem(item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
              </v-list-tile-action>
              <!-- <v-list-tile-action>
                <v-btn icon class="mx-0" @click.stop="deleteItem(item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </v-list-tile-action> -->
            </v-list-tile>
            <v-divider></v-divider>
            </template>
        </v-list>
    </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  data () {
    return {
      expanded: false,
      newTemplateValid: false,
      editExtraIndex: -1,
      editItemIndex: -1,
      newTemplateItem: {
        text: '',
        title: '',
        Index: 0,
        photo: true,
        test: false,
        optional: false
      },
      newTemplateExtra: {
        name: '',
        options: [],
        Index: 0,
        step: 0.01,
        type: 'text',
        permissions: {
          customer: 'none',
          sales: 'read',
          support: 'write'
        },
        optional: false
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Order',
          value: 'Index',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'right',
          sortable: false
        }
      ],
      search: '',
      dialog: false,
      editedIndex: -1,
      engineers: [],
      tableLoading: false,
      editedItem: {
        name: '',
        optional: true,
        required: false,
        Index: 0,
        items: [],
        extras: []
      },
      defaultItem: {
        name: '',
        optional: true,
        required: false,
        Index: 0,
        items: [],
        extras: []
      }
    }
  },
  created () {
    this.tableLoading = true
    this.$store.dispatch('fetchDeviceTypes')
  },
  computed: {
    templates () {
      return this.$store.getters.deviceTypes
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New template' : 'Edit template'
    },
    extrasList () {
      let extrasList = []
      for (let template of this.templates) {
        if (template.extras !== undefined) {
          for (let extra of template.extras) {
            if (extrasList.indexOf(extra.name) === -1) {
              extrasList.push(extra.name)
            }
          }
        }
      }
      return extrasList
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    'newTemplateExtra.type' (val) {
      console.log(val)
      if (val === 'sim') {
        this.newTemplateExtra.name = 'SIM'
      } else if (val === 'uid') {
        this.newTemplateExtra.required = true
      }
    }
  },
  methods: {
    addNewTemplateItem () {
      if (this.editItemIndex === -1) {
        this.editedItem.items.push(this.newTemplateItem)
      } else {
        this.editedItem.items[this.editItemIndex] = this.newTemplateItem
      }
      this.editItemIndex = -1
      this.newTemplateItem = {
        text: '',
        title: '',
        photo: true,
        test: false,
        optional: false
      }
    },
    addNewTemplateExtra () {
      if (this.editExtraIndex === -1) {
        this.editedItem.extras.push(this.newTemplateExtra)
      } else {
        this.editedItem.extras[this.editExtraIndex] = this.newTemplateExtra
      }
      this.editExtraIndex = -1
      this.newTemplateExtra = {
        name: '',
        options: [],
        Index: 0,
        step: 0.01,
        type: 'text',
        permissions: {
          customer: 'none',
          sales: 'read',
          support: 'write'
        },
        optional: false
      }
    },
    cancelExtra () {
      this.editExtraIndex = -1
      this.newTemplateExtra = {
        name: '',
        options: [],
        Index: 0,
        step: 0.01,
        type: 'text',
        permissions: {
          customer: 'none',
          sales: 'read',
          support: 'write'
        },
        default: '',
        optional: false
      }
    },
    cancelItem () {
      this.editItemIndex = -1
      this.newTemplateItem = {
        text: '',
        title: '',
        photo: true,
        test: false,
        optional: false
      }
    },
    moveItemUp (item) {
      let templates = [...this.templates]
      let index = templates.indexOf(item)
      let x = templates[index]
      templates[index] = templates[index - 1]
      templates[index - 1] = x
      templates[index - 1].Index = index - 1
      templates[index].Index = index
      // this.templates = templates
      fireStore.collection('deviceType').doc(templates[index].id).set(templates[index], {merge: true})
      fireStore.collection('deviceType').doc(templates[index - 1].id).set(templates[index - 1], {merge: true})
    },
    moveItemDown (item) {
      let templates = [...this.templates]
      let index = templates.indexOf(item)
      let x = templates[index]
      templates[index] = templates[index + 1]
      templates[index + 1] = x
      templates[index + 1].Index = index + 1
      templates[index].Index = index
      // this.templates = templates
      fireStore.collection('deviceType').doc(templates[index].id).set(templates[index], {merge: true})
      fireStore.collection('deviceType').doc(templates[index + 1].id).set(templates[index + 1], {merge: true})
    },
    moveExtraDown (index) {
      let temp = this.editedItem.extras[index]
      this.editedItem.extras[index] = this.editedItem.extras[index + 1]
      this.editedItem.extras[index + 1] = temp
      this.$forceUpdate()
    },
    moveExtraUp (index) {
      let temp = this.editedItem.extras[index]
      this.editedItem.extras[index] = this.editedItem.extras[index - 1]
      this.editedItem.extras[index - 1] = temp
      this.$forceUpdate()
    },
    moveTemplateItemDown (index) {
      let temp = this.editedItem.items[index]
      this.editedItem.items[index] = this.editedItem.items[index + 1]
      this.editedItem.items[index + 1] = temp
      this.$forceUpdate()
    },
    moveTemplateItemUp (index) {
      let temp = this.editedItem.items[index]
      this.editedItem.items[index] = this.editedItem.items[index - 1]
      this.editedItem.items[index - 1] = temp
      this.$forceUpdate()
    },
    editItem (item) {
      this.editedIndex = this.templates.indexOf(item)
      this.editedItem = {...this.defaultItem, ...item}
      this.editedItem.Index = this.editedItem.Index || this.editedIndex + 1
      this.dialog = true
    },

    deleteItem (item) {
      confirm('Are you sure you want to delete this item?') && fireStore.collection('deviceType').doc(item.id).delete()
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      for (let extra in this.editedItem.extras) {
        if (this.editedItem.extras[extra].default === undefined) {
          this.editedItem.extras[extra].default = ''
        }
      }
      if (this.editedIndex > -1) {
        fireStore.collection('deviceType').doc(this.editedItem.id).set(this.editedItem, {merge: true})
        .then(() => {
          this.close()
        })
      } else {
        this.editedItem.Index = this.templates.length + 1
        fireStore.collection('deviceType').add(this.editedItem)
        .then((docRef) => {
          this.close()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Device.vue?504ffa06